
// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import CategoryPage from "./components/CategoryPage";
import HomePage from "./components/HomePage";
import GameDetails from "./components/GameDetails";
import SearchBox from "./components/SearchBox";
import Login from "./components/Login";
import LoginHeader from "./components/LoginHeader";
import ExistingUserNotcharged from "./components/ExistingUserNotCharged";
import UserLogin from "./components/UserLogin";
import { gaPageView } from "./analytics";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    gaPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  const checkCookie = () => document.cookie.includes("gameofyy");

  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route path="/home" element={<HomePage />} />
        <Route path="/home/login" element={<Login />} />
        <Route path="/home/not-charged" element={<ExistingUserNotcharged />} />
        <Route path="/home/header" element={<LoginHeader />} />
        <Route path="/home/games/:gameid" element={<GameDetails />} />
        <Route path="/home/category/:categoryName" element={<CategoryPage />} />
        <Route path="/home/search" element={<SearchBox />} />
        <Route path="/home/check" element={<UserLogin />} />
        {/* Example if you later gate by cookie: */}
        {/* <Route path="/home" element={checkCookie() ? <HomePage/> : <Navigate to="/home/login" />} /> */}
      </Routes>
    </Router>
  );
}

export default App;


// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// import CategoryPage from "./components/CategoryPage";
// import HomePage from "./components/HomePage";
// import GameDetails from "./components/GameDetails";
// import SearchBox from "./components/SearchBox";
// import Login from "./components/Login";
// import LoginHeader from "./components/LoginHeader";
// import ExistingUserNotcharged from "./components/ExistingUserNotCharged";
// import UserLogin from "./components/UserLogin";

// function App() {
//   // Function to check if the "gameoffy" cookie exists
//   const checkCookie = () => {
//     // Replace this with your logic to check the existence of the "gameoffy" cookie
//     const gameoffyCookie = document.cookie.includes("gameofyy");
//     return gameoffyCookie;
//   };

//   return (
//     <div>
//       <Router>
//         <Routes>
//           {/* <Route
//             path="/home"
//             element={
//               checkCookie() ? <HomePage /> : <Navigate to="/home/login" />
//             }
//           /> */}
          
//           <Route
//             path="/home"
//             element={
//               <HomePage />
//             }
//           />
//           <Route path="/home/login" element={<Login />} />

//           <Route
//             path="/home/not-charged"
//             element={<ExistingUserNotcharged />}
//           />
//           <Route path="/home/header" element={<LoginHeader />} />

//           <Route
//             path="/home/games/:gameid"
//             element={
//               <GameDetails />
//             }
//           />


//           <Route
//             path="/home/category/:categoryName"
//             element={
//               <CategoryPage />
//             }
//           />

//           <Route
//             path="/home/search"
//             element={
//               <SearchBox />
//             }
//           />

//           <Route
//             path="/home/check"
//             element={<UserLogin />
//             }
//           />
//         </Routes>
//       </Router>
//     </div>
//   );
// }

// export default App;
